"use strict";

import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
var __decorateClass = function __decorateClass(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
import React, { createRef, forwardRef } from "react";
import { createPortal } from "react-dom";
import { Transition } from "react-transition-group";
import observeRect from "@reach/observe-rect";
import getPortalRoot from "../../../utils/getPortalRoot";
import IconButton from "../IconButton/IconButton";
import forceReflow from "../../../utils/forceReflow";
import { Observer, observer } from "mobx-react";
import { action, computed, observable } from "mobx";
import classNames from "classnames";
import { Layer, Popover, PopoverTheme } from "../../..";
import { darkTheme, spacing } from "../../../tokens/tokens-css";
import * as styles from "./Toolbar-css";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import ReactResizeDetector from "react-resize-detector";
export var ToolbarPositionType = /* @__PURE__ */function (ToolbarPositionType2) {
  ToolbarPositionType2["Element"] = "element";
  ToolbarPositionType2["None"] = "none";
  return ToolbarPositionType2;
}(ToolbarPositionType || {});
var isElementBasedAutoposition = function isElementBasedAutoposition(props) {
  return props.positionType === "element" /* Element */;
};

var elementBasedPropsChanged = function elementBasedPropsChanged(props, prevProps) {
  return props.element === prevProps.element && props.offset === prevProps.offset && props.visible === prevProps.visible;
};
var Toolbar = /*#__PURE__*/function (_React$Component) {
  _inherits(Toolbar, _React$Component);
  var _super = _createSuper(Toolbar);
  function Toolbar(props) {
    var _this;
    _classCallCheck(this, Toolbar);
    _this = _super.call(this, props);
    _this.position = {
      x: 0,
      y: 0
    };
    _this.toolbarRef = createRef();
    _this.setUpElementBasedAutoposition = function () {
      if (!isElementBasedAutoposition(_this.props)) {
        return;
      }
      if (_this.elementRectObserver) {
        _this.elementRectObserver.unobserve();
      }
      if (!_this.props.element || !_this.props.visible) {
        return;
      }
      _this.elementRectObserver = observeRect(_this.props.element, function (rect) {
        _this.elementRect = rect;
        _this.onTargetOrElementReposition();
      });
      _this.elementRectObserver.observe();
    };
    _this.onTargetOrElementReposition = function () {
      var _a;
      if (!isElementBasedAutoposition(_this.props)) {
        return;
      }
      var _assertThisInitialize = _assertThisInitialized(_this),
        toolbarRect = _assertThisInitialize.toolbarDimensions,
        elementRect = _assertThisInitialize.elementRect;
      if (!toolbarRect) {
        return;
      }
      if (!elementRect) {
        return;
      }
      var offset = (_a = _this.props.offset) != null ? _a : 16;
      var x = elementRect.left + elementRect.width / 2 - toolbarRect.width / 2;
      var y = elementRect.top - (toolbarRect == null ? void 0 : toolbarRect.height) - offset;
      _this.setPosition({
        x: x,
        y: y
      });
    };
    _this.setPosition = function (newPosition) {
      _this.position = newPosition;
    };
    if (_this.shouldUsePortal) {
      _this.toolbarPortalRoot = getPortalRoot("toolbar-root");
    }
    return _this;
  }
  _createClass(Toolbar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (isElementBasedAutoposition(this.props)) {
        this.setUpElementBasedAutoposition();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (isElementBasedAutoposition(this.props) && isElementBasedAutoposition(prevProps) && !elementBasedPropsChanged(this.props, prevProps)) {
        this.setUpElementBasedAutoposition();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _a;
      (_a = this.elementRectObserver) == null ? void 0 : _a.unobserve();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var position = this.position,
        toolbarRef = this.toolbarRef,
        toolbarPortalRoot = this.toolbarPortalRoot;
      var _this$props = this.props,
        visible = _this$props.visible,
        positionType = _this$props.positionType,
        children = _this$props.children,
        className = _this$props.className,
        onMouseDown = _this$props.onMouseDown;
      var maybeMountInPortal = this.shouldUsePortal && toolbarPortalRoot ? function (value) {
        return createPortal(value, toolbarPortalRoot);
      } : function (value) {
        return value;
      };
      return /* @__PURE__ */React.createElement(Layer, null, function (_ref) {
        var zIndex = _ref.zIndex;
        return /* @__PURE__ */React.createElement(Transition, {
          mountOnEnter: true,
          unmountOnExit: true,
          in: visible,
          timeout: 400,
          onEnter: forceReflow
        }, function (status) {
          return /* @__PURE__ */React.createElement(Observer, null, function () {
            var _assignInlineVars;
            return maybeMountInPortal( /* @__PURE__ */React.createElement(ReactResizeDetector, {
              targetRef: toolbarRef,
              onResize: function onResize(width, height) {
                if (!width || !height) {
                  return;
                }
                _this2.toolbarDimensions = {
                  height: height,
                  width: width
                };
                if (!isElementBasedAutoposition(_this2.props)) {
                  return;
                }
                _this2.onTargetOrElementReposition();
              }
            }, /* @__PURE__ */React.createElement("div", {
              className: classNames(styles.wrapper({
                manualPosition: positionType === "none" /* None */
              }), "kl-toolbar kl-toolbar--".concat(status), darkTheme, className, _defineProperty({}, "kl-toolbar--manual-position", positionType === "none")),
              onMouseDown: onMouseDown,
              style: __spreadValues(__spreadValues({}, _this2.props.autoStack ? {
                zIndex: zIndex
              } : {}), position ? assignInlineVars((_assignInlineVars = {}, _defineProperty(_assignInlineVars, styles.toolbarX, "".concat(Math.round(position.x) || 0, "px")), _defineProperty(_assignInlineVars, styles.toolbarY, "".concat(Math.round(position.y) || 0, "px")), _assignInlineVars)) : {}),
              ref: toolbarRef
            }, /* @__PURE__ */React.createElement("div", {
              className: "kl-toolbar__content kl-toolbar__content--".concat(status, " ").concat(styles.content({
                status: status
              }))
            }, children))));
          });
        });
      });
    }
  }, {
    key: "shouldUsePortal",
    get: function get() {
      return this.props.positionType !== "none" /* None */;
    }
  }]);
  return Toolbar;
}(React.Component);
Toolbar.defaultProps = {
  autoStack: true
};
__decorateClass([observable.ref], Toolbar.prototype, "position", 2);
__decorateClass([action], Toolbar.prototype, "setPosition", 2);
__decorateClass([computed], Toolbar.prototype, "shouldUsePortal", 1);
Toolbar = __decorateClass([observer], Toolbar);
export { Toolbar as default };
var ToolbarButton = forwardRef(function (_a, ref) {
  var _b = _a,
    onClick = _b.onClick,
    selected = _b.selected,
    icon = _b.icon,
    props = __objRest(_b, ["onClick", "selected", "icon"]);
  var handleClick = function handleClick(event) {
    event.stopPropagation();
    onClick == null ? void 0 : onClick(event);
  };
  return /* @__PURE__ */React.createElement(IconButton, __spreadValues({
    ref: ref,
    icon: icon,
    className: "kl-toolbar__button ".concat(styles.button),
    "aria-pressed": selected,
    onClick: handleClick
  }, props));
});
export var ToolbarPopover = function ToolbarPopover(props) {
  return /* @__PURE__ */React.createElement(Popover, __spreadProps(__spreadValues({}, props), {
    theme: PopoverTheme.Dark,
    offset: spacing.xs
  }));
};
var ToolbarSeparator = function ToolbarSeparator() {
  return /* @__PURE__ */React.createElement("div", {
    className: "kl-toolbar__separator ".concat(styles.separator),
    role: "separator"
  });
};
export { ToolbarButton, ToolbarSeparator };